import { createContext, useContext, useState, ReactNode } from 'react';

interface SupportContextType {
  selectedAudience: string | null;
  setSelectedAudience: (audience: string | null) => void;
}

const SupportContext = createContext<SupportContextType | undefined>(undefined);

export const useSupportContext = () => {
  const context = useContext(SupportContext);
  if (!context) {
    throw new Error('useSupportContext must be used within a SupportProvider');
  }
  return context;
};

export const SupportProvider = ({ children }: { children: ReactNode }) => {
  const [selectedAudience, setSelectedAudience] = useState<string | null>(null);

  return (
    <SupportContext.Provider value={{ selectedAudience, setSelectedAudience }}>
      {children}
    </SupportContext.Provider>
  );
};